/**
 * 組合員の声管理画面inputクラス
 *
 * @export KYMW0A00InputModel
 * @class KYMW0A00InputModel
 */
export class KYMW0A00InputModel {

  /**
   * 画面ＩＤ
   */
  public formId = String('');

  /**
   * Ｐコードリスト
   */
  public pcodeList: Array<any> = new Array<any>();

  /**
   * 生協コード
   */
  public coopCode = String('');

  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 受付番号
   */
  public receiptNum = String('');

  /**
   * 編集ロック情報
   */
  public editLockInfo = String('');

  /**
   * 注文商品区分
   */
  public orderGoodsFlg = String('');

  /**
   * 受付開始受注コード
   */
  public receiptSOrderCode = String('');

  /**
   * 適応開始受注コード
   */
  public startOrderCode = String('');

  /**
   * 注文コード
   */
  public orderNum6Digits = String('');

  /**
   * アイテムコード
   */
  public itemCode = String('');

  /**
   * いつでも注文の商品情報
   */
  public NvalInputList: Array<any> = new Array<any>();

  /**
   * 注文商品区分（コマ割画面遷移用）
   */
  public orderGoodsFlgKoma: Array<any> = new Array<any>();

  /**
   * 注文商品区分２（コマ割画面遷移用）
   */
  public orderGoodsFlgKoma2 = String('');
}
